import { render, staticRenderFns } from "./QuestionBox.vue?vue&type=template&id=fce70056&scoped=true&"
import script from "./QuestionBox.vue?vue&type=script&lang=ts&"
export * from "./QuestionBox.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionBox.vue?vue&type=style&index=0&id=fce70056&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fce70056",
  null
  
)

component.options.__file = "QuestionBox.vue"
export default component.exports